// Autogenerated file
export const sectionTypesEnum = {
    Reports: "Reports",
    FinanceAndAccounting: "FinanceAndAccounting",
};
export const sectionTypes = [
    { label: "Отчеты", value: "Reports" },
    { label: "Финансы и учёт", value: "FinanceAndAccounting" },
];
